import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=5cc4df81&"
import script from "./Inventory.vue?vue&type=script&lang=ts&"
export * from "./Inventory.vue?vue&type=script&lang=ts&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=5cc4df81&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports